export { default } from '@fhs-legacy/frontend/src/components/store-info-modal';
export { ErrorBoundary } from '@fhs/routing/src/components/page-dev-error-boundary';
